import React from 'react';

const Footer = () => {
  return (
    <footer className="footer" data-testid="main-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">Annie's Butterfly Creations</h3>
            <p className="footer-text">Handcrafted custom pens and accessories</p>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/shop">Shop</a></li>
              <li><a href="/admin/login">Admin</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-heading">Contact</h4>
            <p className="footer-text">Email: anniebutterflycreations@gmail.com</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>© 2025 Annie's Butterfly Creations. All rights reserved.</p>
        </div>
      </div>

      <style jsx>{`
        .footer {
          background: linear-gradient(135deg, #FF9B9B 0%, #B4A7FF 50%, #A7FFD4 100%);
          color: white;
          padding: 3rem 2rem 1.5rem;
          margin-top: 4rem;
        }

        .footer-container {
          max-width: 1400px;
          margin: 0 auto;
        }

        .footer-content {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 2rem;
          margin-bottom: 2rem;
        }

        .footer-title {
          font-family: 'Playfair Display', serif;
          font-size: 1.3rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
        }

        .footer-heading {
          font-family: 'Playfair Display', serif;
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 0.75rem;
        }

        .footer-text {
          font-size: 0.9rem;
          opacity: 0.95;
          line-height: 1.6;
        }

        .footer-links {
          list-style: none;
        }

        .footer-links li {
          margin-bottom: 0.5rem;
        }

        .footer-links a {
          color: white;
          text-decoration: none;
          font-size: 0.9rem;
          opacity: 0.95;
          transition: opacity 0.3s ease;
        }

        .footer-links a:hover {
          opacity: 1;
          text-decoration: underline;
        }

        .footer-bottom {
          text-align: center;
          padding-top: 2rem;
          border-top: 1px solid rgba(255, 255, 255, 0.2);
          font-size: 0.85rem;
          opacity: 0.9;
        }

        @media (max-width: 768px) {
          .footer {
            padding: 2rem 1rem 1rem;
          }

          .footer-content {
            grid-template-columns: 1fr;
            gap: 1.5rem;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;